/**
 * Helpers for turning a translucent brush overlay into the black-and-white
 * mask that mask-based models (e.g. Ideogram Object Removal) expect:
 * white = remove, black = keep.
 */

/** Minimum alpha for a pixel to count as painted. Anti-aliased brush edges below this are dropped. */
export const MASK_ALPHA_THRESHOLD = 16;

/**
 * Convert the RGBA pixels of the stroke overlay into mask pixels.
 * Every painted pixel becomes opaque white, everything else opaque black —
 * the stroke's own color and opacity are irrelevant.
 */
export function strokesToMaskPixels(strokes: Uint8ClampedArray): Uint8ClampedArray {
  const out = new Uint8ClampedArray(strokes.length);
  for (let i = 0; i < strokes.length; i += 4) {
    const painted = strokes[i + 3]! >= MASK_ALPHA_THRESHOLD;
    const value = painted ? 255 : 0;
    out[i] = value;
    out[i + 1] = value;
    out[i + 2] = value;
    out[i + 3] = 255;
  }
  return out;
}

/** Whether the overlay contains any painted pixel at all. */
export function hasPaintedPixels(strokes: Uint8ClampedArray): boolean {
  for (let i = 3; i < strokes.length; i += 4) {
    if (strokes[i]! >= MASK_ALPHA_THRESHOLD) return true;
  }
  return false;
}
